<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick" @changeCompany="changeCompany"></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg zt">
          <time-search ref="timeSearch" :control="{ data: timeData }" @timeControlClick="bindgetSearchElem">
          </time-search>
        </div>
        <div class="box-row zt">
          <div class="el-col-lg-4-8 dn-content-bg">
            <div class="num">综合能源({{ integratedUnit }})</div>
            <div class="num bgR tec">{{ usages.integratedEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showPower">
            <div class="num">总用电量({{ powerUnit }})</div>
            <div class="num bgR tpc">{{ usages.powerEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showWater">
            <div class="num">总用水量({{ waterUnit }})</div>
            <div class="num bgR twc">{{ usages.waterEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showGas">
            <div class="num">总用天然气量({{ gasUnit }})</div>
            <div class="num bgR tngu">{{ usages.gasEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showDiesel">
            <div class="num">总用柴油量({{ dieselUnit }})</div>
            <div class="num bgR tdc">{{ usages.dieselEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showSteam">
            <div class="num">总用蒸汽量({{ steamUnit }})</div>
            <div class="num bgR taosu">{{ usages.steamEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showGasol">
            <div class="num">总用液化石油量({{ gasolUnit }})</div>
            <div class="num bgR">{{ usages.gasolEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showAirCompress">
            <div class="num">压缩空气量({{ airCompressUnit }})</div>
            <div class="num bgR">{{ usages.aircompressEnergy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg" v-if="showN2">
            <div class="num">氮气({{ N2Unit }})</div>
            <div class="num bgR">{{ usages.N2Energy }}</div>
          </div>
          <div class="el-col-lg-4-8 dn-content-bg zt">
            <div class="num">总产量({{ productUnit }})</div>
            <div class="num bgR tto">
              {{ usages.totalProduct ? usages.totalProduct : "-" }}
            </div>
          </div>
        </div>
        <div class="bg-box box-magin dn-content-bg zt yield-energy-consumption">
          <div style="display: flex">
            <!-- <el-radio-group v-model="tabUnit">
              <el-radio-button label="value">产量单耗</el-radio-button>
            </el-radio-group> -->
            <p class="title">产量单耗</p>

            <div style="display: flex; flex: 1; flex-flow: row-reverse">
              <div style="display: flex; align-items: center; margin-left: 10px">
                <div style="
                    width: 18px;
                    height: 8px;
                    background: #0080FF;
                    margin-right: 10px;
                  "></div>
                行业
              </div>
              <div style="display: flex; align-items: center">
                <div style="
                    width: 18px;
                    height: 8px;
                    background: #CCCC00;
                    margin-right: 10px;
                  "></div>
                企业
              </div>
            </div>
          </div>
          <div class="tab-con">
            <el-row :gutter="10" class="rowBox">
              <!-- v-show="showEngry" -->
              <div class="rowItem" v-if="showEngry">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart"></div>
                  <div class="chart-unit">
                    （{{ integratedUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">综合能源</div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.integratedEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.integratedEnergy.energy > 0
                            ? 'big'
                            : showConsumption.integratedEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.integratedEnergy.energy }}
                      </div>
                    </div>
                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.integratedEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.integratedEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.integratedEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.integratedEnergy.huanbi != "-"
                            ? showConsumption.integratedEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.integratedEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.integratedEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.integratedEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- v-show="showPower" -->
              <div class="rowItem" v-if="showPower">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-2"></div>
                  <div class="chart-unit">
                    （{{ powerUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    电{{ tabUnit === "value" ? "产量" : "产值" }}单耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.powerEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.powerEnergy.energy > 0
                            ? 'big'
                            : showConsumption.powerEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.powerEnergy.energy }}
                      </div>
                    </div>
                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.powerEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.powerEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.powerEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.powerEnergy.huanbi != "-"
                            ? showConsumption.powerEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>
                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.powerEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.powerEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.powerEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- v-show="showWater" -->
              <div class="rowItem" v-if="showWater">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-3"></div>
                  <div class="chart-unit">
                    （{{ waterUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    水{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.waterEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.waterEnergy.energy > 0
                            ? 'big'
                            : showConsumption.waterEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.waterEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.waterEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.waterEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.waterEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.waterEnergy.huanbi != "-"
                            ? showConsumption.waterEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.waterEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.waterEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.waterEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- v-show="showSteam" -->
              <div class="rowItem" v-if="showGas">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-4"></div>
                  <div class="chart-unit">
                    （{{ gasUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    天然气{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.gasEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.gasEnergy.energy > 0
                            ? 'big'
                            : showConsumption.gasEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.gasEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.gasEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.gasEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.gasEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.gasEnergy.huanbi != "-"
                            ? showConsumption.gasEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.gasEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.gasEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.gasEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowItem" v-if="showDiesel">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-5"></div>
                  <div class="chart-unit">
                    （{{ dieselUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    柴油{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.dieselEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.dieselEnergy.energy > 0
                            ? 'big'
                            : showConsumption.dieselEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.dieselEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.dieselEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.dieselEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.dieselEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.dieselEnergy.huanbi != "-"
                            ? showConsumption.dieselEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.dieselEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.dieselEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.dieselEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowItem" v-if="showSteam">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-6"></div>
                  <div class="chart-unit">
                    （{{ steamUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    蒸汽{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.steamEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.steamEnergy.energy > 0
                            ? 'big'
                            : showConsumption.steamEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.steamEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.steamEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.steamEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.steamEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.steamEnergy.huanbi != "-"
                            ? showConsumption.steamEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.steamEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.steamEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.steamEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowItem" v-if="showGasol">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-7"></div>
                  <div class="chart-unit">
                    （{{ gasolUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    液化石油气{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.gasolEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.gasolEnergy.energy > 0
                            ? 'big'
                            : showConsumption.gasolEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.gasolEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.gasolEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.gasolEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.gasolEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.gasolEnergy.huanbi != "-"
                            ? showConsumption.gasolEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.gasolEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.gasolEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.gasolEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowItem" v-if="showAirCompress">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-8"></div>
                  <div class="chart-unit">
                    （{{ airCompressUnit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    压缩空气量{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.aircompressEnergy.energy == '-'
                            ? 'equal'
                            : showConsumption.aircompressEnergy.energy > 0
                            ? 'big'
                            : showConsumption.aircompressEnergy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.aircompressEnergy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.aircompressEnergy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.aircompressEnergy.huanbi > 0
                            ? 'big'
                            : showConsumption.aircompressEnergy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.aircompressEnergy.huanbi != "-"
                            ? showConsumption.aircompressEnergy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.aircompressEnergy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.aircompressEnergy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.aircompressEnergy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rowItem" v-if="showN2">
                <div class="chart-box dn-content-bg">
                  <div class="chart-content" id="pieChart-9"></div>
                  <div class="chart-unit">
                    （{{ N2Unit }}/{{
                      tabUnit === "value" ? productUnit : "人"
                    }}）
                  </div>
                  <div class="chart-title zt">
                    氮气{{ tabUnit === "value" ? "产量" : "产值" }}能耗
                  </div>
                  <div class="chart-foot">
                    <div class="chart-foot-item">
                      <div>{{ showConsumptionTime }}</div>
                      <div class="chart-num" :class="
                          showConsumption.N2Energy.energy == '-'
                            ? 'equal'
                            : showConsumption.N2Energy.energy > 0
                            ? 'big'
                            : showConsumption.N2Energy.energy == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{ showConsumption.N2Energy.energy }}
                      </div>
                    </div>

                    <div class="chart-foot-item">
                      <div>环比趋势</div>
                      <div class="chart-num" :class="
                          showConsumption.N2Energy.huanbi == '-'
                            ? 'equal'
                            : showConsumption.N2Energy.huanbi > 0
                            ? 'big'
                            : showConsumption.N2Energy.huanbi == 0
                            ? 'equal'
                            : 'small'
                        ">
                        {{
                          showConsumption.N2Energy.huanbi != "-"
                            ? showConsumption.N2Energy.huanbi + "%"
                            : "-"
                        }}
                      </div>
                    </div>

                    <div class="icon-content">
                      <i class="iconfont" :class="
                          showConsumption.N2Energy.huanbi == '-'
                            ? 'icon-dengyu equal'
                            : showConsumption.N2Energy.huanbi > 0
                            ? 'icon-shangzhang big'
                            : showConsumption.N2Energy.huanbi == 0
                            ? 'icon-dengyu equal'
                            : 'icon-xiajiang small'
                        "></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clear"></div>
            </el-row>
          </div>
        </div>

        <div class="bg-box box-magin dn-content-bg zt">
          <div>
            <el-radio-group class="radio" v-model="tabType">
              <el-radio-button label="integrated">综合能源</el-radio-button>
              <el-radio-button label="power" v-if="showPower">电</el-radio-button>
              <el-radio-button label="water" v-if="showWater">水</el-radio-button>
              <el-radio-button label="gas" v-if="showGas">天然气</el-radio-button>
              <el-radio-button label="diesel" v-if="showDiesel">柴油</el-radio-button>
              <el-radio-button label="steam" v-if="showSteam">蒸汽</el-radio-button>
              <el-radio-button label="gasol" v-if="showGasol">液化石油气</el-radio-button>
              <el-radio-button label="airCompress" v-if="showAirCompress">压缩空气</el-radio-button>
              <el-radio-button label="N2" v-if="showN2">氮气</el-radio-button>
            </el-radio-group>
          </div>
          <div class="tab-con">
            <el-row :gutter="10">
              <el-col :span="24">
                <div class="chart-box dn-content-bg">
                  <!-- <div class="chart-bar-title dn-title-bg">
                    {{ tabUnit === "value" ? "产量" : "产值" }}单耗趋势
                  </div> -->
                  <div class="title">
                    {{ tabUnit === "value" ? "产量" : "产值" }}单耗趋势
                  </div>
                  <div class="chart-bar-content" id="chartBar" v-resize="resize"></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="bg-box box-magin dn-content-bg">
          <nk-table id="table" :data="tableData" :noDataTitle="'该时间段暂无数据'" :columns="columns" :border="false" :rowselect="true">
          </nk-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
// import { DataType, TreeTab, NkLeftTree } from "_c/index.js";
import { findDataByParam } from "@/utils/index.js";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import NkTable from "@/components/common/NkTable";
import * as utils from "@/utils/index.js";
import echarts from "echarts";
import newup from "@/assets/image/yxfx/dqyxfx/icon-top.png";
import newdown from "@/assets/image/yxfx/dqyxfx/icon-bottom.png";
import newequal from "@/assets/image/yxfx/dqyxfx/equal.png";
import BtnShow from "@/components/common/BtnShow.vue";
import dateTool from "@/utils/dateTool";
import ResizeContainer from "@/components/common/resizeContainer.vue";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: {
    TimeSearch,
    TabTree,
    NkTable,
    BtnShow,
    ResizeContainer,
  },

  data () {
    return {
      tabShow: true,
      timeData: [],
      newup: newup,
      newdown: newdown,
      newequal: newequal,
      typeIndex: 0,
      leftTreeStaticData: [],
      leftTreeData: [],
      selectNode: [],
      defaultCheckedKeys: [],
      currentNodekey: "",
      elem: null,
      toTime: "toTime",
      alarnclass: "alarnclass",
      tabUnit: "value",
      tabType: "integrated",
      barChart: null,
      pieChart1: null,
      pieChart2: null,
      pieChart3: null,
      pieChart4: null,
      pieChart5: null,
      pieChart6: null,
      pieChart7: null,
      pieChart8: null,
      pieChart9: null,
      usages: {
        integratedEnergy: "",
        totalPosSteamQuantity: "",
        totalPosWaterQuantity: "",
        totalPosEnergyQuantity: "",
        area: "",
        totalNumber: "",
      },
      viewTreeData: [],
      showConsumption: {
        steamEnergy: {
          huanbi: "",
          energy: "",
        },
        waterEnergy: {
          huanbi: "",
          energy: "",
        },
        powerEnergy: {
          huanbi: "",
          energy: "",
        },
        gasEnergy: {
          huanbi: "",
          energy: "",
        },
        gasolEnergy: {
          huanbi: "",
          energy: "",
        },
        aircompressEnergy: {
          huanbi: "",
          energy: "",
        },
        N2Energy: {
          huanbi: "",
          energy: "",
        },
        dieselEnergy: {
          huanbi: "",
          energy: "",
        },
        integratedEnergy: {
          huanbi: "",
          energy: "",
        },
      },
      showConsumptionTime: "",
      //#产量单耗趋势
      productConsumptionTrend: {},
      perCapitaConsumption: {},
      maxMainValue: null,
      energyUsageTrend: null,
      tdpConsumptionTrend: null, //产值单耗
      areaConsumptionTrend: null, //面均单耗趋势
      areaConsumption: null, //面均单耗趋势
      energyUsageTable: null, //表格数据
      columns: [],
      tableData: [],
      unit: "",
      tables: {},
      fa: {} /*  阈值线*/,
      timeData: [],
      unitTDPConsumption: {},
      showPower: false /* 电 */,
      showSteam: false /* 蒸汽 */,
      showWater: false /* 水 */,
      showGas: false /* 天然气 */,
      showDiesel: false /* 柴油 */,
      showGasol: false /*液化石油气 */,
      showAirCompress: false /*压缩空气 */,
      showN2: false /*氮气 */,
      showEngry: false,
      powerUnit: "" /* 电单位*/,
      waterUnit: "" /* 水单位 */,
      gasUnit: "" /* 天然气单位 */,
      gasolUnit: "" /* 液化石油气单位 */,
      airCompressUnit: "" /* 压缩空气单位 */,
      N2Unit: "" /* 压缩空气单位 */,
      dieselUnit: "" /* 柴油单位 */,
      steamUnit: "" /* 蒸汽单位 */,
      integratedUnit: "" /* 综合能源单位 */,
      productUnit: "" /* 产量单位 */,
    };
  },
  created () { },
  mounted () { },
  activated () { },
  watch: {
    tabUnit (val) {
      //修改图表的值
      this.setPieChartData(val);
      this.setEnergyData(this.tabType);
    },
    tabType (val) {
      this.setEnergyData(val);
    },
  },
  methods: {
    resize () {
      let vm = this;
      if (vm.barChart) {
        vm.barChart.resize();
      }
    },
    bindShowCheckBoxContent () {
      let vm = this;
      vm.showCheckBoxContent = !vm.showCheckBoxContent;
    },
    checkChange (e, index) {
      let vm = this;
    },
    clicksummit (type) {
      let vm = this;
      if (type == "sure") {
        let vm = this;
        let checkeds = vm.checkData.filter((obj) => obj.checked == true);
        let codes = handleData.setCodes("power");
        codes = codes.concat(checkeds);
        vm.getMaxMin(codes);
        vm.getDqyxfxData(codes);
      } else {
        vm.checkData = JSON.parse(JSON.stringify(vm.checkDataTemp));
      }
      this.dialogFormVisible = false;
    },
    changeCompany (companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(companyId, "/nygl/nxdb", null)
        .then((res) => {
          if (res) {
            vm.viewTreeData = findDataByParam("viewTree", true, res.data);
            vm.timeData = findDataByParam("timeData", true, res.data);
            vm.$refs.timeSearch.position = vm.timeData[0].type;
            let energy = findDataByParam("energy", true, res.data);
            let unitData = findDataByParam("energyUnit", true, res.data);
            vm.showEngry = true;
            vm.showPower =
              energy.findIndex((obj) => obj == "power") > -1 ? true : false;
            vm.showSteam =
              energy.findIndex((obj) => obj == "steam") > -1 ? true : false;
            vm.showWater =
              energy.findIndex((obj) => obj == "water") > -1 ? true : false;
            vm.showGas =
              energy.findIndex((obj) => obj == "gas") > -1 ? true : false;
            vm.showDiesel =
              energy.findIndex((obj) => obj == "diesel") > -1 ? true : false;
            vm.showGasol =
              energy.findIndex((obj) => obj == "gasol") > -1 ? true : false;
            vm.showAirCompress =
              energy.findIndex((obj) => obj == "airCompress") > -1
                ? true
                : false;
            vm.showN2 =
              energy.findIndex((obj) => obj == "N2") > -1 ? true : false;
            for (const i in unitData) {
              if (i == "power") {
                vm.powerUnit = unitData[i];
              }
              if (i == "water") {
                vm.waterUnit = unitData[i];
              }
              if (i == "gas") {
                vm.gasUnit = unitData[i];
              }
              if (i == "diesel") {
                vm.dieselUnit = unitData[i];
              }
              if (i == "steam") {
                vm.steamUnit = unitData[i];
              }
              if (i == "gasol") {
                vm.gasolUnit = unitData[i];
              }
              if (i == "airCompress") {
                vm.airCompressUnit = unitData[i];
              }
              if (i == "N2") {
                vm.N2Unit = unitData[i];
              }
              if (i == "integrated") {
                vm.integratedUnit = unitData[i];
              }
              if (i == "product") {
                vm.productUnit = unitData[i];
              }
            }
            vm.$nextTick(() => {
              vm.initPieChart();
              vm.initBarChart("chartBar");
            });
          }
        });
    },
    clickoTherAdd () {
      this.checkDataTemp = JSON.parse(JSON.stringify(this.checkData));
      this.dialogFormVisible = true;
    },
    //树加载
    tabTreeDefault (node) {
      let vm = this;
      vm.selectNodes = [node];
      let time = new Date();
      let dateType = vm.timeData[0].type;
      let startTime, endTime;
      if (dateType == "day") {
        time = new Date();
        startTime = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
        time.setDate(time.getDate() + 1);
        endTime = dateTool.format(new Date(time), "yyyy-MM-dd") + " 00:00:00";
      } else if (dateType == "month") {
        time = new Date();
        startTime = dateTool.format(time, "yyyy-MM") + "/01 00:00:00";
        time.setMonth(time.getMonth() + 1);
        endTime = dateTool.format(new Date(time), "yyyy-MM") + "/01 00:00:00";
      } else if (dateType == "year") {
        time = new Date();
        startTime = dateTool.format(time, "yyyy") + "/01/01 00:00:00";
        time.setFullYear(time.getFullYear() + 1);
        endTime = dateTool.format(new Date(time), "yyyy") + "/01/01 00:00:00";
      }
      vm.selectedDate = {
        dateType: dateType,
        endTime: endTime,
        startTime: startTime,
      };
      vm.bindgetSearchElem(vm.selectedDate);
    },
    tabTreeClick (e) {
      this.selectNodes = [e];
      this.bindgetSearchElem(this.selectedDate);
    },
    bindgetSearchElem (e) {
      this.selectedDate = e;
      this.getData(this.selectNodes[0].measureId);
    },
    getData (id) {
      let vm = this;
      let dateType = this.selectedDate.dateType;
      let startDate = this.selectedDate.startTime;
      let endDate = this.selectedDate.endTime;
      let startDateOne = this.selectedDate.startTime;
      let endDateOne = this.selectedDate.endTime;
      if (typeof startDate == "string") {
        let newStart = startDate;
        startDate = newStart;
      }
      if (typeof endDate == "string") {
        let newStart = endDate;
        endDate = newStart;
      }
      // alert(startDate)
      //   alert(endDate)
      switch (dateType) {
        case "day":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate), //2020-10-09
            "yyyy年MM月dd日"
          );
          dateType = 1;
          break;
        case "month":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate),
            "yyyy年MM月"
          );
          dateType = 2;
          break;
        case "year":
          vm.showConsumptionTime = dateTool.format(
            new Date(startDate),
            "yyyy年"
          );
          dateType = 3;
          break;
      }
      vm.$api.beadmin
        .getEnergyEfficiencyBenchmark(
          id,
          dateType,
          startDateOne,
          endDateOne,
          false
        )
        .then((res) => {
          //
          vm.$api.beadmin
            .getBenchmarkKPI(id, dateType, startDateOne, endDateOne)
            .then((res2) => {
              if (res) {
                for (const i in res.data.usages) {
                  let item = res.data.usages[i];
                  if (item) {
                    res.data.usages[i] = parseFloat(item).toFixed(2);
                  }
                }
                vm.usages = res.data.usages;
                vm.fa = res.data.fa;
                vm.tables = res.data.tables;
                vm.unitTDPConsumption = res.data.unitTDPConsumption;
                vm.productConsumptionTrend = res.data.productConsumptionTrend;
                vm.energyUsageTrend = res.data.energyUsageTrend;
                vm.tdpConsumptionTrend = res.data.tdpConsumptionTrend;
                vm.energyUsageTable = res.data.energyUsageTable;
                vm.setEnergyData(vm.tabType);
                let maxMainData = res2.data;
                let maxMainValue = {
                  output: {
                    integrated: {
                      all: {
                        min: 0,
                        max: 1.5,
                      },
                      local: {
                        min: 0,
                        max: 11,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    ele: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    water: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    gas: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    diesel: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    steam: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    gasol: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    airCompress: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    N2: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                  },
                  value: {
                    integrated: {
                      all: {
                        min: 0,
                        max: 1.0,
                      },
                      local: {
                        min: 0,
                        max: 4,
                      },
                      industry: {
                        min: 0,
                        max: 2,
                      },
                    },
                    ele: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    water: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    gas: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    diesel: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    steam: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    gasol: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    airCompress: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                    N2: {
                      all: {
                        min: 0,
                        max: 1,
                      },
                      local: {
                        min: 0,
                        max: 1,
                      },
                      industry: {
                        min: 0,
                        max: 1,
                      },
                    },
                  },
                };
                for (let index = 0; index < maxMainData.length; index++) {
                  const element = maxMainData[index];
                  let obj = {};
                  switch (element.name) {
                    case "integrated":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.integrated = obj.output;
                      maxMainValue.value.integrated = obj.value;
                      break;
                    case "power":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.ele = obj.output;
                      maxMainValue.value.ele = obj.value;
                      break;
                    case "water":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.water = obj.output;
                      maxMainValue.value.water = obj.value;
                      break;
                    case "gas":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.gas = obj.output;
                      maxMainValue.value.gas = obj.value;
                      break;
                    case "diesel":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.diesel = obj.output;
                      maxMainValue.value.diesel = obj.value;
                      break;
                    case "steam":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.steam = obj.output;
                      maxMainValue.value.steam = obj.value;
                      break;
                    case "gasol":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.gasol = obj.output;
                      maxMainValue.value.gasol = obj.value;
                      break;
                    case "aircompress":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.airCompress = obj.output;
                      maxMainValue.value.airCompress = obj.value;
                      break;
                    case "N2":
                      obj = vm.getMinMax(element.kpis);
                      maxMainValue.output.N2 = obj.output;
                      maxMainValue.value.N2 = obj.value;
                      break;
                  }
                }
                vm.maxMainValue = maxMainValue;
                vm.setPieChartData(vm.tabUnit);
              }
            });
        });
    },
    /**
     * 传入类型。类型为人均或面均
     */
    setPieChartData (type) {
      let vm = this;
      //   this.getData(this.selectNodes[0].measureId);
      let maxMainValue = vm.maxMainValue;
      if (maxMainValue) {
        //最大最小。地方、行业的最大最小值
        let data = maxMainValue[type];
        let option1 = vm.pieChart1.getOption();
        // let option1 = vm.pieChart1!=null?vm.pieChart1.getOption():'';
        let option2 = vm.pieChart2 != null ? vm.pieChart2.getOption() : "";
        let option3 = vm.pieChart3 != null ? vm.pieChart3.getOption() : "";
        let option4 = vm.pieChart4 != null ? vm.pieChart4.getOption() : "";
        let option5 = vm.pieChart5 != null ? vm.pieChart5.getOption() : "";
        let option6 = vm.pieChart6 != null ? vm.pieChart6.getOption() : "";
        let option7 = vm.pieChart7 != null ? vm.pieChart7.getOption() : "";
        let option8 = vm.pieChart8 != null ? vm.pieChart8.getOption() : "";
        let option9 = vm.pieChart9 != null ? vm.pieChart9.getOption() : "";
        if (type === "output") {
          vm.showConsumption = vm.perCapitaConsumption;
        } else {
          vm.showConsumption = vm.unitTDPConsumption;
        }
        for (const i in vm.showConsumption) {
          let item = vm.showConsumption[i];
          for (const j in item) {
            let jtem = item[j];
            if (jtem && jtem != "-") {
              vm.showConsumption[i][j] = parseFloat(jtem).toFixed(2);
            }
          }
        }
        let obj = vm.showConsumption;
        /* 综合能源 */
        if (vm.pieChart1) {
          vm.pieChart1.setOption(
            vm.setOption(
              data["integrated"],
              option1,
              obj.integratedEnergy.energy
            ),
            true
          );
        }
        /* 电 */
        if (vm.pieChart2) {
          vm.pieChart2.setOption(
            vm.setOption(data["ele"], option2, obj.powerEnergy.energy),
            true
          );
        }

        /* 水 */
        if (vm.pieChart3) {
          vm.pieChart3.setOption(
            vm.setOption(data["water"], option3, obj.waterEnergy.energy),
            true
          );
        }

        /* 天然气 */
        if (vm.pieChart4) {
          vm.pieChart4.setOption(
            vm.setOption(data["gas"], option4, obj.gasEnergy.energy),
            true
          );
        }
        /* 柴油 */
        if (vm.pieChart5) {
          vm.pieChart5.setOption(
            vm.setOption(data["diesel"], option5, obj.dieselEnergy.energy),
            true
          );
        }
        /* 蒸汽 */
        if (vm.pieChart6) {
          vm.pieChart6.setOption(
            vm.setOption(data["steam"], option6, obj.steamEnergy.energy),
            true
          );
        }
        /* 液化石油气 */
        if (vm.pieChart7) {
          vm.pieChart7.setOption(
            vm.setOption(data["gasol"], option7, obj.gasolEnergy.energy),
            true
          );
        }
        /* 液化石油气 */
        if (vm.pieChart8) {
          vm.pieChart8.setOption(
            vm.setOption(
              data["airCompress"],
              option8,
              obj.aircompressEnergy.energy
            ),
            true
          );
        }
        /* 氮气 */
        if (vm.pieChart9) {
          vm.pieChart9.setOption(
            vm.setOption(data["N2"], option8, obj.N2Energy.energy),
            true
          );
        }
      }
    },
    getMinMax (kpis) {
      let obj = {
        output: {
          all: {
            min: 0,
            max: 1,
          },
          local: {
            min: 0,
            max: 1,
          },
          industry: {
            min: 0,
            max: 1,
          },
        },
        value: {
          all: {
            min: 0,
            max: 1,
          },
          local: {
            min: 0,
            max: 1,
          },
          industry: {
            min: 0,
            max: 1,
          },
        },
      };
      for (let j = 0; j < kpis.length; j++) {
        const item = kpis[j];
        switch (item.name) {
          case "production" /* 面均 */:
            obj.value.all.min = item.min;
            obj.value.all.max = item.max;
            break;
          case "production_Local":
            obj.value.local.min = item.min;
            obj.value.local.max = item.max;
            break;
          case "production_Industry":
            obj.value.industry.min = item.min;
            obj.value.industry.max = item.max;
            break;
        }
      }
      return obj;
    },
    setOption (optionMinMaxData, option, value) {
      option.series[0].min = optionMinMaxData["all"].min; /* 最大最小值 */
      option.series[0].max = optionMinMaxData["all"].max;
      option.series[2].min = optionMinMaxData["local"].min; /* 本地最大最小值 */
      option.series[2].max = optionMinMaxData["local"].max;
      option.series[3].min =
        optionMinMaxData["industry"].min; /* 行业最大最小值 */
      option.series[3].max = optionMinMaxData["industry"].max;
      option.series[4].min = optionMinMaxData["all"].min;
      option.series[4].max = optionMinMaxData["all"].max;
      option.series[2].axisLine.lineStyle.color = [
        [
          optionMinMaxData["local"].min / optionMinMaxData["all"].max,
          "#e6e6e6",
        ],
        [
          optionMinMaxData["local"].max / optionMinMaxData["all"].max,
          // "#f7ba2a",
          '#0080FF'
        ],
        [1, "#e6e6e6"],
      ];
      option.series[3].axisLine.lineStyle.color = [
        [
          optionMinMaxData["industry"].min / optionMinMaxData["all"].max,
          "#e6e6e6",
        ],
        [
          optionMinMaxData["industry"].max / optionMinMaxData["all"].max,
          // "#4e6be3",
          '#CCCC00'
        ],
        [1, "#e6e6e6"],
      ];
      if (value) {
        option.series[4].data = [value];
      } else {
        option.series[4].data = [0];
      }
      return option;
    },
    setEnergyData (type) {
      let vm = this;
      const keys = {
        integrated: "integratedEnergy",
        power: "powerEnergy",
        water: "waterEnergy",
        gas: "gasEnergy",
        diesel: "dieselEnergy",
        steam: "steamEnergy",
        gasol: "gasolEnergy",
        airCompress: "aircompressEnergy",
        N2: "N2Energy",
      };
      /* 表格数据开始 */
      let tableData;
      if (vm.tabUnit == "value") {
        tableData = vm.tables[keys[type]];
      } else {
        tableData = vm.tables[keys[type]];
      }
      let columns = [
        {
          prop: "energy",
          label: "能源类型",
          show: true,
          width: "180",
          fixed: "left",
          align: "center",
        },
      ];
      let data = {
        coulmns: ["1时", "2时", "3时"],
        values: [1, 2, 3],
      };
      let rows = {};
      let energy = null;
      if (vm.tabType == "integrated") {
        energy = "综合能源";
      } else if (vm.tabType == "power") {
        energy = "电";
      } else if (vm.tabType == "water") {
        energy = "水";
      } else if (vm.tabType == "gas") {
        energy = "天然气";
      } else if (vm.tabType == "diesel") {
        energy = "柴油";
      } else if (vm.tabType == "steam") {
        energy = "蒸汽";
      } else if (vm.tabType == "gasol") {
        energy = "液化石油气";
      } else if (vm.tabType == "airCompress") {
        energy = "压缩空气";
      } else if (vm.tabType == "N2") {
        energy = "氮气";
      }
      rows = {};
      tableData[0].coulmns.forEach((temp, j) => {
        columns.push({
          prop: temp,
          label: temp,
          show: true,
          align: "center",
        });
        // rows['type']=vm.tabUnit==="value"?'面均单耗趋势':'人均单耗趋势'
        rows["energy"] = energy;
        rows[temp] =
          tableData[1].values[j] && tableData[1].values[j] != "-"
            ? parseFloat(tableData[1].values[j]).toFixed(2)
            : "-";
      });
      this.columns = columns;
      vm.tableData = [rows];
      /* 表格数据结束 */
      vm.getUnit();
      let obj = vm.productConsumptionTrend[0][keys[type]];
      let xData = [];
      let yData = [];
      Object.keys(obj).forEach((key) => {
        xData.push(key);
        yData.push(obj[key] === "" ? "-" : Number(obj[key]).toFixed(2));
      });
      vm.barChart = echarts.init(document.getElementById("chartBar"));
      //设置chart
      vm.barChart.setOption({
        xAxis: {
          data: xData,
        },
        yAxis: {
          name: vm.unit,
        },
        grid: {
          x: 70,
          y: 30,
        },
        series: [
          {
            name: "耗能",
            type: "bar",
            barWidth: "80%",
            data: yData,
            markLine: {
              data: [
                {
                  // yAxis: linevalue
                  yAxis: vm.fa["product"][vm.tabType],
                },
              ],
              label: {
                normal: {
                  formatter: vm.fa["product"][vm.tabType], // 这儿设置安全基线
                  // formatter: energy+":"+vm.fa[vm.tabUnit][vm.tabType]        // 这儿设置安全基线
                },
              },
            },
          },
        ],
        toolbox: {
          show: true,
          feature: {
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
      });
    },
    /* 获取echarts单位 */
    getUnit () {
      let vm = this;
      switch (vm.tabType) {
        case "integrated":
          vm.unit = vm.integratedUnit + "/" + vm.productUnit;
          break;
        case "power":
          vm.unit = vm.powerUnit + "/" + vm.productUnit;
          break;
        case "water":
          vm.unit = vm.waterUnit + "/" + vm.productUnit;
          break;
        case "gas":
          vm.unit = vm.gasUnit + "/" + vm.productUnit;
          break;
        case "diesel":
          vm.unit = vm.dieselUnit + "/" + vm.productUnit;
          break;
        case "steam":
          vm.unit = vm.steamUnit + "/" + vm.productUnit;
          break;
        case "gasol":
          vm.unit = vm.gasolUnit + "/" + vm.productUnit;
          break;
        case "airCompress":
          vm.unit = vm.airCompressUnit + "/" + vm.productUnit;
          break;
        case "N2":
          vm.unit = vm.N2Unit + "/" + vm.productUnit;
          break;
      }
    },
    initPieChart (id) {
      let vm = this;
      // 基于准备好的dom，初始化echarts实例
      vm.pieChart1 = echarts.init(document.getElementById("pieChart"));
      vm.pieChart2 = vm.showPower
        ? echarts.init(document.getElementById("pieChart-2"))
        : null;
      vm.pieChart3 = vm.showWater
        ? echarts.init(document.getElementById("pieChart-3"))
        : null;
      vm.pieChart4 = vm.showGas
        ? echarts.init(document.getElementById("pieChart-4"))
        : null;
      vm.pieChart5 = vm.showDiesel
        ? echarts.init(document.getElementById("pieChart-5"))
        : null;
      vm.pieChart6 = vm.showSteam
        ? echarts.init(document.getElementById("pieChart-6"))
        : null;
      vm.pieChart7 = vm.showGasol
        ? echarts.init(document.getElementById("pieChart-7"))
        : null;
      vm.pieChart8 = vm.showAirCompress
        ? echarts.init(document.getElementById("pieChart-8"))
        : null;
      vm.pieChart9 = vm.showN2
        ? echarts.init(document.getElementById("pieChart-9"))
        : null;
      let option = {
        backgroundColor: "#ffffff",
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            /* 这层只是数字 */ name: "最外圈数字刻度",
            type: "gauge",
            z: 2,
            radius: "160%",
            splitNumber: 5,
            startAngle: 180,
            endAngle: 0,
            min: 1,
            // min: 0,
            max: 100,
            center: ["50%", "90%"],
            axisLine: {
              // 坐标轴线
              lineStyle: {
                width: 25,
                opacity: 0, //刻度背景宽度
              },
            },
            splitLine: {
              show: false,
            },
            data: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#988bbe",
                fontSize: 14,
              },
              formatter: "{value}",
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: 0,
            },
          },
          {
            startAngle: 180, //开始角度 左侧角度   /* 这层是透明刻度 */
            endAngle: 0, //结束角度 右侧
            radius: "100%",
            // startAngle: 180, //开始角度 左侧角度
            // endAngle: 0, //结束角度 右侧
            // radius: "100%",
            // center: ["50%", "90%"],
            center: ["50%", "90%"],
            splitNumber: 5,
            type: "gauge",
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: [[1, "rgba(0,0,0,0)"]],
              },
            },
            //刻度标签。
            axisTick: {
              show: true,
              splitNumber: 7,
              lineStyle: {
                color: "#4c647c",
                width: 1,
              },
              length: -8,
            }, //刻度样式
            splitLine: {
              show: true,
              length: -20,
              lineStyle: {
                color: "#4c647c",
              },
            }, //分隔线样式
            detail: {
              show: false,
            },
            pointer: {
              show: false,
            },
          },
          {
            type: "gauge",
            radius: "80%",
            name: "企业",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  [0.3, "#e6e6e6"],
                  [0.6, "#f7ba2a"],
                  [1, "#e6e6e6"],
                ],
              },
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
              length: "80%",
              width: 3,
            },
            title: {
              show: false,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
            },
          },
          {
            type: "gauge",
            radius: "50%",
            name: "行业",
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  [0.1, "#e6e6e6"],
                  [0.6, "#4e6be3"],
                  [1, "#e6e6e6"],
                ],
              },
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
              length: 60,
              width: 3,
            },
            title: {
              show: true,
              offsetCenter: [20, "-26%"], // x, y，单位px
              textStyle: {
                color: "#4c647c",
                fontSize: 16,
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
            },
          },
          {
            type: "gauge",
            radius: 120,
            startAngle: 180, //开始角度 左侧角度
            endAngle: 0, //结束角度 右侧
            center: ["50%", "90%"],
            splitNumber: 0, //刻度数量
            min: 0,
            max: 100,
            axisLine: {
              show: false,
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: true,
              length: "80%",
              width: 3,
            },
            title: {
              show: true,
              offsetCenter: [20, "-26%"], // x, y，单位px
              textStyle: {
                color: "#4c647c",
                fontSize: 16,
              },
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, 14],
              color: "#4c647c",
              formatter: function (params) {
                if (isNaN(params)) {
                  params = "-";
                }
                return params;
              },
              textStyle: {
                fontSize: 16,
              },
            },
            data: [50],
          },
        ],
      };
      // 指定图表的配置项和数据
      vm.pieChart1.setOption(option);
      vm.showPower ? vm.pieChart2.setOption(option) : null;
      vm.showWater ? vm.pieChart3.setOption(option) : null;
      vm.showGas ? vm.pieChart4.setOption(option) : null;
      vm.showDiesel ? vm.pieChart5.setOption(option) : null;
      vm.showSteam ? vm.pieChart6.setOption(option) : null;
      vm.showGasol ? vm.pieChart7.setOption(option) : null;
      vm.showAirCompress ? vm.pieChart8.setOption(option) : null;
      vm.showN2 ? vm.pieChart9.setOption(option) : null;
    },
    initBarChart (id) {
      let vm = this;
      // 基于准备好的dom，初始化echarts实例
      vm.barChart = echarts.init(document.getElementById(id));
      let option = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          top: 40,
          bottom: "8%",
          //   containLabel: true  /* 容器是否包含x轴 */
        },
        xAxis: {
          type: "category",
          data: [],
          //   axisTick: {
          //     alignWithLabel: true
          //   }
        },
        // visualMap: {
        //     show: false,
        //     pieces: [
        //         {
        //         gt: 0,
        //         lte: 0.5,          //这儿设置基线上下颜色区分 基线下面为绿色
        //         // lte: linevalue,          //这儿设置基线上下颜色区分 基线下面为绿色
        //         color: '#03d6d6'
        //     }, {

        //         gt: 0.5,          //这儿设置基线上下颜色区分 基线上面为红色
        //         color: '#e91642'
        //     }]
        // },
        yAxis: [
          {
            type: "value",
            max: (value) => {
              return (value.max * 1.2).toFixed(2);
            },
          },
        ],
        series: [
          {
            name: "耗能",
            type: "bar",
            barWidth: "60%",
            data: [],
          },
        ],
      };
      // 指定图表的配置项和数据

      if (id == "chartBar") {
        vm.barChart.setOption(option);
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/* ie11兼容样式 可删除 --start*/
.yield-energy-consumption .tab-con {
  min-height: 600px\0;
}
.yield-energy-consumption .tab-con .rowItem {
  flex: 0 1 320px;
}
/* ie11兼容样式 可删除 --end*/

.yield-energy-consumption {
  .title {
  }
}
.title {
  margin: 8px 0;
}
.zt {
  color: #000;
}
.ulbox {
  display: flex;
  flex-wrap: wrap;
}
.ulbox > li {
  line-height: 30px;
  font-size: 18px;
  list-style: none;
  width: 50%;
}

.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  width: 100%;
  height: 100%;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  flex-flow: column;
}
.top {
  line-height: 40px;
}
.top ul {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
}
.top ul li {
  float: left;
  font-size: 16px;
  margin-right: 20px;
  line-height: 30px;
}
.top ul li:first-child {
  margin-left: 0px;
}
.red {
  color: #ed6a93;
}
.tab-pane {
  position: relative;
}
.check-box {
  position: absolute;
  top: 0px;
  right: 54px;
  width: 180px;
  height: 150px;
  z-index: 999;
  overflow: auto;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn-img {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px;
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn {
  position: absolute;
  right: 10px;
  top: 4px;
  z-index: 999;
  cursor: pointer;
}
.check-box ul {
  width: 100%;
  list-style: none;

  margin: 0px;
  padding: 0px;
}
.check-box ul li {
  padding: 4px;
}

.top {
  line-height: 40px;
  background: #fff;
  border-radius: 4px;

  padding: 14px;
  box-sizing: content-box;
}

.box-magin {
  margin-top: 14px;
}
.bg-box {
  border-radius: 4px;
  padding: 14px;
  box-sizing: content-box;
  border: 1px solid #f3eded;
  text-align: left;
  color: #000;
}
.bg-box1 {
  border-radius: 4px;
  /* padding: 14px; */
  box-sizing: content-box;
  border: 1px solid #f3eded;
  height: 300px;
}
.box-row {
  margin-top: 14px;
  box-sizing: content-box;
  color: #000;
  width: 100%;
  display: flex;
}
.bgR {
  background: #409eff;
  font-weight: 600;
  color: #fff;
  font-size: 18px !important;
}
.bgB {
  background: #3fbcf2;
}
.el-col-lg-4-8 {
  /* width: calc(25% - 20px); */
  flex: 1;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
  height: 80px;
  padding: 10px;
  display: flex;
  flex-flow: column;
  text-align: center;
  font-size: 14px;
}
.num {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 4px;
}
.tab-con {
  margin-top: 10px;
}
.chart-box {
  /* width:100%;
    height: 300px;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    border-radius: 4px;
    border: 1px solid #f3eded; */
  width: 100%;
  height: 300px;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  border-radius: 4px;
  border: 1px solid #f3eded;
}
.chart-content {
  width: 100%;
  height: 250px;
  margin: 0px auto;
  margin-top: -60px;
}
.chart-unit {
  font-size: 14px;
  text-align: center;
  color: #aaadf9;
}
.chart-title {
  text-align: center;
  font-weight: bold;
  padding: 6px 0px;
  color: #999999;
}
.chart-foot {
  border-top: 1px solid #f3eded;
  display: flex;
  flex: 1;
}
.chart-num {
  font-weight: bold;
}
.chart-foot-item {
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.chart-foot-item div {
  flex: 1;
  display: flex;
  align-items: center;
}
.chart-bar-title {
  width: 100%;
  text-align: left;
  line-height: 30px;
  padding: 0px 10px;
  color: #fff;
}
.chart-bar-content {
  width: 100%;
  margin-top: 10px;
  height: 400px;
}
.icon-content {
  display: flex;
  align-items: center;
  padding-right: 10px;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
.equal {
  color: #ffe793;
}
.rowBox {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.rowItem {
  width: 334px;
  margin: 0 5px;
}

.tec {
  background: linear-gradient(180deg, #e8f8ff 0%, #cceeff 100%);
}

.tpc {
  background: linear-gradient(180deg, #ddf4ed 0%, #b8e6d6 100%);
}

.taosu {
  background: linear-gradient(180deg, #f4f4ce 0%, #e6e6a1 100%);
}

.tto {
  background: linear-gradient(180deg, #e8e4fb 0%, #ccc4f5 100%);
}

::v-deep .is-active span.el-radio-button__inner {
  background-color: #0080ff;
  border-color: #0080ff;
}
</style>